module.exports = __webpack_public_path__ + "static/media/BigCaslon.ec50ac41.ttf";